// FitAura is intentionally always-dark "cyber-chic". The Light/Dark/System
// picker was removed because the CSS palette is identical in :root and .dark
// (see src/index.css). This file now only exposes initTheme() to lock the
// `dark` class on <html> at boot for consistency.
//
// Type re-export kept so older imports (`type Theme`) still type-check during
// the transition. Safe to delete once nothing imports it.
export type Theme = "dark";

/** Call once at app boot (before React renders). */
export function initTheme() {
  if (typeof document === "undefined") return;
  const root = document.documentElement;
  root.classList.add("dark");
  root.style.colorScheme = "dark";
  // Clean up any legacy preference left in localStorage from older versions.
  try { localStorage.removeItem("tryfit-theme"); } catch { /* ignore */ }
}
